import { render } from "./ViewNotificationContent.vue?vue&type=template&id=1b7acf54&ts=true"
import script from "./ViewNotificationContent.vue?vue&type=script&lang=ts"
export * from "./ViewNotificationContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__